export const MemberRoles = [
  { id: "Admin", name: "Admin" },
  { id: "Member", name: "Member" },
];
